import { InfoText, Label } from "features/LeadGen/pages/LeadDetails/LeadDetails.styles.ts";
import { UnavailableDataPlaceholderText } from "constants/text.ts";
import React from "react";

interface LabeledFieldProps {
	label: string;
	value: string | undefined | null;
	dataTestId?: string;
}

// NOSONAR TODO: we can probably reuse this everywhere

const LabeledField = ({ label, value, dataTestId }: LabeledFieldProps) => {
	return (
		<Label>
			{label}
			<InfoText data-testid={dataTestId ?? "data-field"}>{value || UnavailableDataPlaceholderText}</InfoText>
		</Label>
	);
};

export default LabeledField;
